import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="d-flex align-items-center">
      <div className="container">
        <nav className="justify-content-center d-flex">
          <ul className="nav justify-content-center">
            <li className="nav-item">
              <Link className="nav-link" to="/listing">
                Listings
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/support">
                Support
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                About Us
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/privacy">
                Privacy Policy
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/cookies-policy">
                Cookies Policy
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/terms-conditions">
                Terms & Conditions
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                Contact Us
              </Link>
            </li>
          </ul>
        </nav>
        <div className="social d-flex justify-content-center align-items-center my-4">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/hubsquares"
          >
            <i className="fab fa-facebook-square"></i>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/hubsquares/"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://twitter.com/hubsquares"
          >
            <i className="fab fa-twitter-square"></i>
          </a>
          {/* <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://youtube.com/hubsquares"
          >
            <i className="fab fa-youtube-square"></i>
          </a> */}
        </div>

        <p className="my-2 text-center text-white">
          Copyright Hubsquares © 2020
        </p>
      </div>
    </footer>
  );
};

export default Footer;
